import { OkrKeyResultUpdate } from "server/models"

export interface OkrKeyResultUpdateList { [keyResultId: number]: OkrKeyResultUpdate[] }

export type OkrKeyResultUpdateValidation = { [key in keyof OkrKeyResultUpdate]?: string}

export interface OkrKeyResultUpdateState {
    updateList: OkrKeyResultUpdateList
    updateEdit: OkrKeyResultUpdate

    reloadEdit: boolean
}

export const OKR_KEY_RESULT_UPDATE_LIST = "OKR_KEY_RESULT_UPDATE_LIST"
export const OKR_KEY_RESULT_UPDATE_EDIT = "OKR_KEY_RESULT_UPDATE_EDIT"
export const OKR_KEY_RESULT_UPDATE_RELOAD_EDIT = "OKR_KEY_RESULT_UPDATE_RELOAD_EDIT"
